import * as React from 'react';
import { Command as Cmdk } from 'cmdk';

export const Command = ({ className = '', ...props }: React.ComponentProps<typeof Cmdk>) => (
  <Cmdk
    className={`rounded-md border border-border bg-popover text-foreground shadow-sm ${className}`}
    {...props}
  />
);

export const CommandInput = ({ className = '', ...props }: React.ComponentProps<'input'>) => (
  <div className="border-b border-border p-2">
    <input
      className={`w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground ${className}`}
      {...props}
    />
  </div>
);

export const CommandList = ({ className = '', ...props }: React.ComponentProps<'div'>) => (
  <div className={`max-h-64 overflow-auto p-1 ${className}`} {...props} />
);

export const CommandEmpty = ({ className = '', ...props }: React.ComponentProps<'div'>) => (
  <div className={`p-3 text-sm text-muted-foreground ${className}`} {...props} />
);

export const CommandItem = ({ className = '', ...props }: React.ComponentProps<'div'>) => (
  <div
    className={`cursor-pointer select-none rounded px-2 py-1.5 text-sm hover:bg-secondary ${className}`}
    {...props}
  />
);
